import type { StandoutItem } from './types';

/** Sources are filled after generation; without one a row has nothing to open. */
export const standoutHasSource = (standout: StandoutItem): boolean =>
  Boolean(standout.sources?.length);
